export const configes = {
  domainName: "SellYourLHDCar",
  domainURL: "sellyourlhdcar.com",
  domainId: "677e1120a287ec34fe5cff6a",
};